<div class="aya-course-selector">
  <div class="sticky-search-bar">
    <lx-searcher (searchTriggered)="filterCourse($event)" [autofocus]="visible" [queryReset]="visible" data-qa="ayaCourseSelector_search"></lx-searcher>
  </div>
  <div class="listbox-options listbox-options--margin">
    <lx-list-box
      [group]="true"
      [options]="(filteredGroupedCourses$ | async) ?? []"
      [(ngModel)]="selectedCourseCode"
      (ngModelChange)="triggerSelectedCourseChanged()"
      data-qa="ayaCourseSelector_list"
    >
      <ng-template #customGroupTemplate let-group pTemplate="group">
        <div class="aya-course-selector__group">
          <img [ngSrc]="group.iconUrl" [width]="15" [height]="15" [alt]="group.label" />
          <span class="aya-course-selector__group__label">{{ group.label }}</span>
          <div class="aya-course-selector__group__description">{{ group.description }}</div>
        </div>
      </ng-template>
    </lx-list-box>
  </div>
</div>
